module.exports = __webpack_public_path__ + "img/xk.62bc9bcf.svg";